import { Loader } from '@mit/hui'
import { LoaderProps } from '@mit/hui/build/components/Loader'
import React, {Suspense,  useEffect } from 'react'
import { useStoreActions, useStoreState } from 'Store'

interface Props {
  App: React.LazyExoticComponent<React.FC<{}>>
  appInitializer: () => void
  loaderProps: LoaderProps
}

export const Initialization: React.FC<Props> = ({ App, appInitializer, loaderProps }) => {
  const { hasAccess, isLoading } = useStoreState((state) => state.LoaderModel)
  // const { hasOutage } = useStoreState((state) => state.RegionModel)

  useEffect(() => {
    appInitializer()
    // eslint-disable-next-line
  }, [])

 

  if (isLoading || !hasAccess ) {
    return (
      <>
        {/* {<AppInitializer />} */}
        <Loader {...loaderProps} hasAccess={hasAccess} isLoading={isLoading} type={hasAccess || isLoading ? 'mit' : 'noAccess'} />
      </>
    )
  }

  return (
    <Suspense fallback={<Loader {...loaderProps} isLoading={isLoading} />}>
    <App />
  </Suspense>
  )
}
